<template>
  <div class="header-container">
<b-container class="no-margin">
    <b-row>
<h1 class="p-color">the vegan ambition</h1>
    </b-row>
</b-container>
<b-container class="header-padding">
      <h3 class="heading-padding">Position: <span class="p-color heading-padding">🙋‍♂️ Owner</span></h3>
      <h3> Project: <span class="p-color heading-padding">🎙 Podcast about Veganism</span></h3>
      <h3> Company: <span class="p-color heading-padding">🤹 Mine</span></h3>
      <h3> Timeline: <span class="p-color heading-padding">⏰ May 2018 - ongoing</span></h3>
    </b-container>
    <b-container>
  <b-row class="header-padding">
  <b-col cols="12" sm="12" md="12" lg="4" xl="4">
<h2>The Vegan Ambition</h2>
<h2><a target="_blank" class="link" href="https://theveganambition.com">theveganambition.com</a></h2>
  </b-col>
    <b-col cols="12" sm="12" md="12" lg="8" xl="8">
      <b-img rounded class="image-size" :src="veganambition_home" img-alt="This is a screenshot of The Vegan Ambition home page, it is pink and fun."></b-img>
    </b-col>
  </b-row>
      </b-container>
      <b-container class="middle-margin">
        <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <h4><span class="heading5">Objectives</span></h4>
<ul>
<li>5,000 Instagram Followers by 2019</li>
<li>3,000 Listens by 2019</li>
<li>Teach people about veganism</li>
<li>Have some Famous people on the podcast</li>
</ul>
 </b-col>
 <b-col cols="12" sm="12" md="6" lg="6" xl="6">
       <h4><span class="heading5">Achievements</span></h4>
       <ul>
       <li>3,000 followers on Instagram (Nov 2018)</li>
       <li>2,000 listens (Nov 2018)</li>
       <li>Had 2 Instagrammers with over 40k followers</li>
       <li>Recorded 19 Episodes</li>
       <li>Released 16 Episodes</li>
       </ul>
 </b-col>
 </b-row>
 </b-container>
<b-container class="header-padding">
<iframe src="https://snapwidget.com/embed/620802" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden; width:100%; "></iframe>
</b-container>
<b-container class="middle-margin">
  <b-row>
  <b-col>
<p class="header-padding2">In the summer of 2018, I was driving, when I had an idea. I’d been in the “vegan” sphere for a while, and noticed that there were many what I would call “extreme” vegans. I’m not talking about the people who do public awareness campaigns or vegan activists. I am talking about the people who, block their non-vegan friends on Facebook, who get mad and disconnect from those who aren’t vegan. There is some understanding that I have about why these people do this. It’s like people who don’t talk to Trump Supporters because of their political views. But at the same time, it doesn’t make sense to me. Why ignore and block these people, when education is so pivotal. </p>
<p>During this time, I had a few friends reach out to me about being vegan. I sent them many texts and gave them a lot of information.</p>
<p>During this drive, it struck me, there aren’t many great areas for vegans and non-vegans to talk. There isn’t a place that accepts people and teaches them. </p>
<h2 class="header-padding"><a class="font-deco">I had a sudden idea, to create a podcast. With the goal to help transition people towards veganism, to allow non-vegans to learn bits about veganism but not be hostile.</a></h2>
<b-img rounded class="image-size" :src="veganambition_about" img-alt="This is a screenshot of the Vegan Ambition About Us page."></b-img>
<p class="header-padding2">By the next week, I was sitting in my friend's apartment with a recording device, asking him about <a target="_blank" class="link" href="https://open.spotify.com/episode/3SqdXFllWtCCiXbYg77UOc">Twizzlers and whether honey is vegan.</a> </p>
<p>As of November 2nd, 2018, I’ve released 16 episodes, I’ve recorded 20, my Instagram has 2700 followers, my podcast has been listened to over 1500 times, and I’ve helped to teach people about veganism. During the summer, I designed and coded a <a target="_blank" class="link" href="https://theveganambition.com">website</a> to help reach more people (it needs a re-design - since I changed my style). I’m growing, and I’m doing what is important to change the world. </p>
<h2 class="header-padding"><a class="font-deco">I don’t pressure people who aren’t vegan, I try to educate them.</a> </h2>
<p>This podcast has taught me a lot. I’ve learned the importance of <a target="_blank" class="link" href="https://www.instagram.com/theveganambition/">Social Media,</a> how to schedule posts and create batches, and I’ve learned how to use hashtags. I’ve learned how to create a podcast, edit it, host it, and do all the background work. I’ve figured out how to normalize and make audio sound better. I still have a lot to learn, but this has been one of the most interesting enterprises of my life and I’m excited to see where it will take me. </p>
 </b-col>
</b-row>
</b-container>
  <b-container>
    <h4 class="header-padding"><span class="heading5">Other Projects</span></h4>
      <b-row>
            <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/snapsuite">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="SnapSuite Inc - Internship Position" :img-src="snapsuite" img-alt="Image of a macbook pro with the home page of an app I designed for SnapSuite." img-top>
                <p class="card-text">
      Customer portal for companies to create work orders. From concept to final working product.
    </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/fashionforchange">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Fashion for Change - Volunteer Position" :img-src="fashionForChange" img-alt="Image of two macbook pros floating with the Fashion For Change Home Page embedded on them." img-top>
                <p class="card-text">
      Website re-design for Fashion For Change. Worked on this as a volunteer.
    </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/glide">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Glide - Capstone Project" :img-src="glide" img-alt="Image of an iPhone with the logo of Glide on it." img-top>
                <p class="card-text">
      Glide is a task-based daily scheduling application for employees with ASD and their managers.
                </p>
          </b-card>
          </router-link>
    </b-col>
  </b-row>
  </b-container>
</div>
</template>

<script>
export default {
  data () {
    return {
      veganambition_home: './../../static/images/veganAmbition/veganambitionHome.jpg',
      veganambition_about: './../../static/images/veganAmbition/veganambitionAbout.jpg',
      glide: './../../static/images/homePage/GlideMockups2.png',
      fashionForChange: './../../static/images/homePage/FashionForChange.jpg',
      snapsuite: './../../static/images/homePage/snapsuite.jpg'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Righteous");

h1 {
  font-family: "Righteous", cursive;
  font-size: 100px;
  padding-left: 25px;
  padding-right: 10px;
}
h2{
  font-weight: 800;
}
.font-deco{
  background: linear-gradient(to bottom, transparent 62%, #00CC99 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    background-size: 100% 100%;
}
.header-padding{
  padding-top:40px;
  padding-bottom: 40px;
}
.header-padding2{
  padding-top:40px;
}
.image-padding{
  margin-top:60px;
  margin-bottom: 60px;
}
.header-container {
  width: 100%;
}
.no-margin {
  padding-left: 0px;
  padding-right: 0px;
}
.link {
  color: #000000;
  text-decoration: underline;
  font-weight: 600;
  text-decoration-color: #00CC99;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #00CC99 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
}
.link:hover {
  background-size: 100% 100%;
  color: #000000;
}
.heading5 {
      color: #6D6E71;
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 700;
}
.card-text {
  color: black;
}
.margin-on-card {
  margin-bottom: 20px;
}
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.image-size{
  width:100%;
  padding:0px !important;
  margin: 0px !important;
}
.middle-margin{
  padding-left: 160px;
  padding-right: 160px;
}
@media screen and (max-width: 992px) {
h1{
    font-size: 100px;
            padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:26px;
}
h3{
  font-size: 25px;
}
  .middle-margin{
  padding-left: 40px;
  padding-right: 40px;
}
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
h1{
    font-size: 65px;
        padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:24px;
}
h3{
  font-size: 25px;
}
.heading-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
}

@media screen and (max-width: 400px) {
h1{
    font-size: 63px;
    padding-left: 25px;
    padding-right: 10px;
}
h3{
  font-size:20px;
}
h2{
  font-size:22px;
}
.heading-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/veganambition.vue